import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SyfLogo from '../logos/SyfLogo';
import { getHeaderContent } from '../../store/contentSlice';
import { isRouteBehindLogin } from '../../utils/helpers';
import { captureAnalyticsDataAttributes } from '../../utils/analytics/analyticsDispatchers';
import ProfileIcon from '../profileMenu/ProfileIcon';
import ProfileMenuList from '../profileMenu/ProfileMenuList';
import { getAccountData } from '../../store/accountListSlice';
import './header.css';

const Header = (): ReactElement => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const { syfLogoAltText }: any = useSelector(getHeaderContent);
  const accounts: any = useSelector(getAccountData);
  const userName = accounts.length > 0 && accounts[0]['cipher.firstName'];
  const handleProfileMenuClick = (event?: any) => {
    event.stopPropagation();
    setIsProfileMenuOpen(!isProfileMenuOpen);
    captureAnalyticsDataAttributes(event);
  };
  const handleClickOutside = () => {
    if (isProfileMenuOpen) {
      setIsProfileMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isProfileMenuOpen) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isProfileMenuOpen]);

  return (
    <header className="col-span-12">
      <div className="wallet-header" data-testid="wallet-header">
        <SyfLogo syfLogoClass="syf-logo" altText={syfLogoAltText} />
        {isRouteBehindLogin() && (
          <>
            <ProfileIcon
              isProfileMenuOpen={isProfileMenuOpen}
              handleProfileMenuClick={handleProfileMenuClick}
              userName={userName}
            />
            {isProfileMenuOpen && (
              <ProfileMenuList
                handleProfileMenuClick={handleProfileMenuClick}
                userName={userName}
              />
            )}
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
